import React, { useState } from 'react'
import clsx from  'clsx';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Fab from '@mui/material/Fab';
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';

import StandardsQuestions from './standards-questions';
import useStyles from './styles'


export default function StandardsIndicators({context, indicator, percent, pending, countAnswered, countTotal }) {
  
  const classes = useStyles()

  const {quizStandardScale = {}, translate} = context

  const {proficient, parcial, noProficient} = quizStandardScale[0] || {};

  const proScoreMaxLimit = proficient?.maxValue || 100;
  const proScoreMinLimit = proficient?.minValue || 75;
  const parcialScoreMaxLimit = parcial?.maxValue || 74;
  const parcialScoreMinLimit = parcial?.minValue || 60;
  const noProScoreMaxLimit = noProficient?.maxValue || 59;
  const noProScoreMinLimit = noProficient?.minValue || 0;

  const indicatorState = ((percent, pending) => (
            pending 
            ? '#fff' 
            : (percent <= proScoreMaxLimit && percent >= proScoreMinLimit)
                ?  proficient?.color
                : (percent <= parcialScoreMaxLimit && percent >= parcialScoreMinLimit)
                    ? parcial?.color
                    : (percent <= noProScoreMaxLimit && percent >= noProScoreMinLimit)
                        ? noProficient?.color
                        : '#fff'
  ))

  const [open, setOpen] = useState(false);
  const [maxWidth, setMaxWidth] = useState('md');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <TableRow key={indicator.id} >
         <TableCell className={classes.tableCell}>
            <Fab 
                variant="extended" 
                size="medium" 
                className={clsx(classes.indicatorLabel)} 
                disableRipple={true}
                disableFocusRipple={true}
                style={{
                  "backgroundColor": indicatorState(percent, pending),
                  "cursor": "default"
                }}>
                {indicator.code}
            </Fab>
         </TableCell>
         <TableCell className={classes.tableCell}>
            <Button className={classes.questionBtn} variant="outlined" onClick={handleClickOpen}>
                {`${countAnswered}/${countTotal}`}
            </Button>
            <Dialog
                onClose={handleClose}
                fullWidth="true"
                maxWidth={maxWidth}
                open={open}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                {`${indicator.code}`}
                <Button onClick={handleClose}
                          sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                          }}>
                        <CloseIcon />
                    </Button>
                </DialogTitle>
                    <StandardsQuestions context={context} questions={indicator.references}/>
            </Dialog>
         </TableCell>
         <TableCell className={classes.tableCell}>
                 {`${percent}%`}
         </TableCell>
         <TableCell className={clsx(classes.tableCell, classes.pendingCell)}>
                { pending &&
                    <Box className={classes.statusWrapper}>
                        <Avatar className={classes.statusDot}>
                            <span>R</span>
                        </Avatar>
                    </Box>
                }
         </TableCell>
     </TableRow>
  )
}
